module.exports = __webpack_public_path__ + "static/media/briefcase--red.4745ff97.svg";